<template>
    <div :class="['chart-drawing-toolbar', { expanded },{ 'align-left': !chartFilters.startSyncView, 'align-right': chartFilters.startSyncView }]">
        <div class="chart-drawing-toolbar-inner">
            <a @click.prevent="pan('left')" ref = "panLeft" @mouseover="showTooltip('panLeft','Quarter Left',true)" @mouseleave="hideTooltip()" :disabled="buttonsDisabled.panLeft">
                <svg class="ico" width="15" height="15">
                    <use xlink:href="#ico-caret"></use>
                </svg>
            </a>
            <a @click.prevent="pan('right')" ref="panRight"  @mouseover="showTooltip('panRight','Quater Right',true)" @mouseleave="hideTooltip()"  :disabled="buttonsDisabled.panRight">
                <svg class="ico ico--right" width="15" height="15">
                    <use xlink:href="#ico-caret"></use>
                </svg>
            </a>
            <a @click.prevent="zoom('out')" ref="zoomOut"  @mouseover="showTooltip('zoomOut','Zoom In',true)" @mouseleave="hideTooltip()" :disabled="buttonsDisabled.zoomIn">
                <svg class="ico" width="15" height="15">
                    <use xlink:href="#ico-chart-zoom-in"></use>
                </svg>
            </a>
            <a @click.prevent="zoom('in')" ref="zoomIn"  @mouseover="showTooltip('zoomIn','Zoom Out',true)" @mouseleave="hideTooltip()" :disabled="buttonsDisabled.zoomOut">
                <svg class="ico" width="15" height="15">
                    <use xlink:href="#ico-chart-zoom-out"></use>
                </svg>
            </a>
            <a @click.prevent="reset" ref="reset"  @mouseover="showTooltip('reset','Reset',true)" @mouseleave="hideTooltip()">
                <svg class="ico" width="15" height="15">
                    <use xlink:href="#ico-chart-reset"></use>
                </svg>
            </a>
            <a @click.prevent="toggleFullscreen" ref="fullScreen"  @mouseover="showTooltip('fullScreen','Full Screen',true)" @mouseleave="hideTooltip()">
                <svg class="ico" width="15" height="15"  v-if="!fullscreen">
                    <use xlink:href="#ico-chart-expand"></use>
                </svg>
                <svg class="ico" width="15" height="15"  v-else>
                    <use xlink:href="#ico-chart-collapse"></use>
                </svg>
            </a>
            <a @click.prevent="exportChartPng" ref="exportChartPng"  @mouseover="showTooltip('exportChartPng','Export to PNG',true)" @mouseleave="hideTooltip()">
                <svg class="ico" width="15" height="15">
                    <use xlink:href="#ico-image-export"></use>
                </svg>
            </a>
            <a @click.prevent="exportChartCsv" ref="exportChartCsv"  @mouseover="showTooltip('exportChartCsv','Export to CSV',true)" @mouseleave="hideTooltip()">
                <svg class="ico" width="15" height="15">
                    <use xlink:href="#ico-csv-export"></use>
                </svg>
            </a>
            <a @click.prevent="toggleExpand" ref="expand"  @mouseover="showTooltip('expand',expanded ? 'Collapse Toolbar':'Expand Toolbar',false)"  @mouseleave="hideTooltip()" >
                <svg class="ico" width="15" height="15" v-if="expanded">
                    <use xlink:href="#ico-chart-minimize"></use>
                </svg>
                <svg class="ico" width="15" height="15" v-else>
                    <use xlink:href="#ico-chart-maximize"></use>
                </svg>
            </a>
        </div>
    </div>
</template>

<script>
import * as d3 from 'd3';
export default {
    props: {
        chart: {
            type: Object,
        },
    },
    data() {
        return {
            fullscreen: false,
            buttonsDisabled: {
                panLeft: false,
                panRight: false,
                zoomIn: false,
                zoomOut: false,
            },
        };
    },
    mounted() {
        this.checkButtonsDisabled();
    },
    computed: {
        expanded() {
            return this.$store.getters['toolbar/isExpanded'];
        },
        chartFilters() {
            return this.$store.getters['chart/getCharts'][this.$store.getters['chart/getCurrentIndex']].filters;
        },
    },
    methods: {
        showTooltip(element,textToDisplay,resizeTooltip){
            const refElement = this.$refs[element].getBoundingClientRect();
            const tooltip = d3.select(`#chart-drawing-${this.chart.chartId}-wrapper`).select('.toolbar-tooltip');
            tooltip.classed('toolbar-tooltip-0',resizeTooltip);
            tooltip.select('h4').html(textToDisplay);
            tooltip.select('h4').style('text-align','center');
            const text = tooltip.select('.event-text');
            text.selectAll('p').remove();
            text.selectAll('div').remove();
            tooltip.select('.divider').style('display','none');
            tooltip.select('.event-revenue').style('display','none');
            tooltip.select('.event-quarter').style('display','none');
               if(refElement && refElement.x && refElement.y) {
                    tooltip.attr('style', `top: ${refElement.y}px; left: ${refElement.x + 18}px;`);
               } else {
                    tooltip.attr('style', `top: ${refElement.top}px; left: ${refElement.left + 18}px;`);
               }

            tooltip.classed('closed', false);
        },
        hideTooltip(){
            const tooltip = d3.select(`#chart-drawing-${this.chart.chartId}-wrapper`).select('.toolbar-tooltip');
            tooltip.classed('toolbar-tooltip-0',false);
            tooltip.classed('closed', true);
        },
        pan(direction) {
            this.chart.drawingService.pan(direction);
        },
        zoom(direction) {
            this.chart.drawingService.xAxisZoom(direction);
        },
        reset() {
            this.chart.drawingService.reset();
        },
        toggleExpand() {
            this.$store.commit('toolbar/toggleExpand', null, {root: true});
        },
        toggleFullscreen() {
            this.fullscreen = !this.fullscreen;
            this.$emit('fullscreen', this.fullscreen);
        },
        checkButtonsDisabled() {
            setInterval(() => {
                if (this.chart.drawingService) {
                    const { xDomain, quarters } = this.chart.drawingService;

                    this.buttonsDisabled.panLeft = xDomain[0] === 0;
                    this.buttonsDisabled.panRight = xDomain[1] === quarters.length - 1;
                    this.buttonsDisabled.zoomIn = xDomain[0] === xDomain[1] - 1 || xDomain[0] === xDomain[1] - 2;
                    this.buttonsDisabled.zoomOut = xDomain[0] === 0 && xDomain[1] === quarters.length - 1;
                }
            }, 500);
        },
        exportChartPng(){
            this.$emit('exportChartPng');
        },
        exportChartCsv(){
            this.$emit('exportChartCsv');
        },
    },
};

</script>

<style lang="scss">
    @import '../../../style/Charts/ViewChart/ToolbarComponent.scss';
</style>
